export default "__VITE_ASSET__ffbbb3b7__"